import React, { FC, useState } from "react";
import {
  IAvaQuestionario as IDMMAvaQuestionario,
  IQuestionario,
} from "@deltasge/marauders-map";
import {
  TableCell,
  TableRow as MUITableRow,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Pencil as EditIcon,
  Delete as DeleteIcon,
  Magnify as VisualizarIcon,
  FormatListChecks as ResponderIcon,
  DotsVertical as MenuIcon,
} from "mdi-material-ui";
import { useMobile } from "hooks/useMobile";

export interface IAvaQuestionario extends IDMMAvaQuestionario {
  questionario: IQuestionario;
}

export const TableRow: FC<{
  avaliacao: IAvaQuestionario;
  handleEdit: (item: IDMMAvaQuestionario) => void;
  handleDelete: (item: IDMMAvaQuestionario) => void;
  handleResponder: (item: IDMMAvaQuestionario) => void;
  handleVisualizar: (item: IDMMAvaQuestionario) => void;
}> = ({
  avaliacao,
  handleEdit,
  handleDelete,
  handleResponder,
  handleVisualizar,
}) => {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const isXl = useMobile("xl");
  const isMd = useMobile("md");

  return (
    <MUITableRow>
      {!isMd && <TableCell>{avaliacao.turma.tituloTurma}</TableCell>}
      <TableCell>
        {avaliacao.aluno
          ? avaliacao.aluno.nomeusual?.rUpper() ||
            avaliacao.aluno.nome?.rUpper()
          : ""}
      </TableCell>
      <TableCell>
        {avaliacao.bimestre == 0 ? "Todas" : avaliacao.bimestre}
      </TableCell>
      {!isMd && !isXl && <TableCell>{avaliacao.questionario.nome}</TableCell>}
      {!isMd && <TableCell>{avaliacao.professor?.nome?.rUpper()}</TableCell>}
      <TableCell sx={{ textAlign: "right" }}>
        {!isMd && (
          <>
            <IconButton color="primary" onClick={() => handleEdit(avaliacao)}>
              <EditIcon />
            </IconButton>
            <IconButton color="error" onClick={() => handleDelete(avaliacao)}>
              <DeleteIcon />
            </IconButton>
            <IconButton onClick={() => handleVisualizar(avaliacao)}>
              <VisualizarIcon />
            </IconButton>
            <IconButton onClick={() => handleResponder(avaliacao)}>
              <ResponderIcon />
            </IconButton>
          </>
        )}
        {isMd && (
          <>
            <IconButton onClick={(e) => setAnchor(e.currentTarget)}>
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchor}
              open={Boolean(anchor)}
              onClose={() => setAnchor(null)}
            >
              <MenuItem
                onClick={() => {
                  setAnchor(null);
                  handleEdit(avaliacao);
                }}
              >
                <ListItemIcon>
                  <EditIcon color="primary" fontSize="small" />
                </ListItemIcon>
                <ListItemText>Editar</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchor(null);
                  handleDelete(avaliacao);
                }}
              >
                <ListItemIcon>
                  <DeleteIcon color="secondary" fontSize="small" />
                </ListItemIcon>
                <ListItemText>Deletar</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchor(null);
                  handleVisualizar(avaliacao);
                }}
              >
                <ListItemIcon>
                  <VisualizarIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Visualizar</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchor(null);
                  handleResponder(avaliacao);
                }}
              >
                <ListItemIcon>
                  <ResponderIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Responder</ListItemText>
              </MenuItem>
            </Menu>
          </>
        )}
      </TableCell>
    </MUITableRow>
  );
};
